import * as yup from "yup";

import { t } from "@/i18n-js/instance";

export const ADD_LINK_FORM_ID = "sidebar-v3-add-link-form";

export const ADD_LINK_VALIDATION_SCHEMA = yup.object().shape({
  name: yup.string().required(t("link_name_required")),
  url: yup.lazy((value: unknown) => {
    if (typeof value === "string" && value.startsWith("mailto:")) {
      return yup
        .string()
        .trim()
        .test("mailto-email", t("link_url_invalid"), mailtoValue => {
          if (!mailtoValue) {
            return false;
          }

          return yup
            .string()
            .email()
            .isValidSync(mailtoValue.replace(/^mailto:/, ""));
        })
        .required(t("link_url_required"));
    }
    return yup
      .string()
      .url(t("link_url_invalid"))
      .required(t("link_url_required"));
  }),
  may_lead_to_purchase: yup.boolean().optional(),
});
